<activar-modal [visible]="true" [closable]="closable" (visibleChange)="onModalClose()">
	<div class="flex-col mx-auto p-5" style="width: 440px">
		@switch (view()) {
			@case ('form') {
				<form [formGroup]="form" (ngSubmit)="onSubmit()" class="flex flex-col gap-5">
					<h2 class="text-center">Crear API key</h2>

					<div class="flex flex-col gap-1">
						<label for="apiKeyName">Nombre</label>
						<input
							type="text"
							id="apiKeyName"
							data-testid="name"
							formControlName="name"
							class="input__base"
							[attr.maxlength]="nameMaxLength"
							(input)="onNameInput()" />
						<div class="flex justify-between text-xs text-gray-500">
							<span></span>
							<span data-testid="counter">{{ nameLength }}/{{ nameMaxLength }}</span>
						</div>
						<app-input-error [control]="form.controls.name" [submitted]="submitted()" />
						@if (form.controls.name.hasError('maxlength') && (form.controls.name.touched || submitted())) {
							<div class="error">El nombre puede tener un máximo de {{ nameMaxLength }} caracteres</div>
						}
						@if (nameServerError()) {
							<div class="error" data-testid="name-server-error">
								El nombre no es válido. Revisalo e intentá de nuevo.
							</div>
						}
					</div>

					<fieldset class="flex flex-col gap-2">
						<legend>Vencimiento</legend>
						<label class="flex items-center gap-2" for="apiKeyExpiration90d">
							<input
								type="radio"
								id="apiKeyExpiration90d"
								data-testid="expiration-90d"
								formControlName="expiration"
								value="90d" />
							90 días
						</label>
						<label class="flex items-center gap-2" for="apiKeyExpirationNever">
							<input
								type="radio"
								id="apiKeyExpirationNever"
								data-testid="expiration-never"
								formControlName="expiration"
								value="never" />
							Sin vencimiento
						</label>
					</fieldset>

					<div class="flex mt-2 items-center justify-center gap-5">
						<activar-button
							data-testid="cancel"
							text="Cancelar"
							fill="out"
							expand="full"
							color="primary"
							type="button"
							[disabled]="submitting()"
							(click)="cancel()" />
						<activar-button
							data-testid="submit"
							text="Crear"
							loadingText="Creando..."
							fill="solid"
							expand="full"
							color="primary"
							type="submit"
							[loading]="submitting()"
							[disabled]="submitting()" />
					</div>
				</form>
			}
			@case ('result') {
				<div class="flex flex-col gap-4">
					<h2 class="text-center">Tu API key</h2>
					<p class="p-3 rounded bg-yellow-100 text-yellow-900 font-semibold" data-testid="notice">
						Copiala ahora. No se va a volver a mostrar.
					</p>
					<input
						type="text"
						readonly
						data-testid="result-key"
						aria-label="API key"
						class="input__base api-key-create__key"
						[value]="createdKey() ?? ''"
						(focus)="$any($event.target).select()" />
					@if (copyFailed()) {
						<div class="error" data-testid="copy-failed">No se pudo copiar, seleccioná y copiá manualmente</div>
					}
					<div class="flex mt-2 items-center justify-center gap-5">
						<activar-button
							data-testid="copy"
							[text]="copied() ? 'Copiada' : 'Copiar'"
							fill="out"
							expand="full"
							color="primary"
							type="button"
							(click)="copy()" />
						<activar-button
							data-testid="done"
							text="Listo"
							fill="solid"
							expand="full"
							color="primary"
							type="button"
							(click)="requestDone()" />
					</div>
				</div>
			}
			@case ('confirmDiscard') {
				<div class="flex flex-col gap-4 text-center">
					<h2>¿Ya copiaste la key?</h2>
					<p>No vas a poder verla de nuevo.</p>
					<div class="flex mt-2 items-center justify-center gap-5">
						<activar-button
							data-testid="confirm-back"
							text="Volver"
							fill="out"
							expand="full"
							color="primary"
							type="button"
							(click)="keepKey()" />
						<activar-button
							data-testid="confirm-discard"
							text="Sí, ya la copié"
							fill="solid"
							expand="full"
							color="danger"
							type="button"
							(click)="confirmDiscard()" />
					</div>
				</div>
			}
		}
	</div>
</activar-modal>
